import React from "react";
import { motion } from "framer-motion";
import Footer from "./Footer";

/**
 * PageShell — wraps each page with its <main> + footer.
 * Nav is rendered at the App level, OUTSIDE this shell, so it persists across
 * page transitions (no flicker).
 */
export const PageShell = ({ children }) => {
  return (
    <div className="App min-h-screen flex flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:bg-navy focus:text-offwhite focus:border focus:border-gold focus:px-4 focus:py-2 focus:text-xs focus:uppercase focus:tracking-[0.22em]"
        data-testid="skip-to-content"
      >
        Skip to content
      </a>
      <main id="main-content" tabIndex={-1} className="flex-1 focus:outline-none">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default PageShell;
